<template>
    <div>
        <div>
            <b-row>
                <!-- details bar -->
                <b-col cols="12">
                    <div style="height: 5rem; border: 1px solid lightgrey; border-radius: 0.4rem;" class="p-1">
                        <!--<div style="text-align: center;" class="card-title">Level Details</div>-->
                        <b-alert class="p-2" :show="levelDetails == null">Select a level</b-alert>
                        <b-overlay :show="isLoadingUsers">
                            <b-form v-if="levelDetails != null">
                                <b-row>
                                    <b-col cols="3" class="">
                                        <label for="">Name</label>
                                        <b-form-input v-model="edit.name"></b-form-input>
                                    </b-col>
                                    <b-col cols="3" class="">
                                        <label for="">Lead User</label>
                                        <vue-typeahead-bootstrap
                                            :showOnFocus="true"
                                            @hit="findUser($event)"
                                            v-model="query"
                                            :data="users"
                                            :minMatchingChars="1"
                                            v-show="users.length > 0"
                                        />
                                        <b-alert :show="users.length == 0" class="mb-0">No users in level</b-alert>
                                    </b-col>
                                    <b-col cols="6" class="mt-4">
                                        <div style="margin-top: 0.15rem;">
                                            <b-button variant="success" @click="saveCurrentLevel">
                                                <i class="fas fa-save" ></i> Save
                                            </b-button>
                                            &nbsp;
                                            <b-button variant="danger" @click="deleteSelectedLevel">
                                                <i class="fas fa-trash-alt"></i> Delete
                                            </b-button>
                                            &nbsp;
                                            |
                                            &nbsp;
                                            <b-dropdown ref="addLevelDropdown" menu-class="addLevelMenu" text="Add Child Level" :disabled="levelDetails != null ? false:true">
                                                <b-dropdown-form class="m-2">
                                                    <b-form-group label="Level Name" @submit.stop.prevent>
                                                        <b-form-input v-model="new_level_name"></b-form-input>
                                                    </b-form-group>
                                                    <b-button class="mt-2 w-100" size="sm" @click="addLevel" variant="success">Save</b-button>
                                                </b-dropdown-form>
                                            </b-dropdown>
                                            &nbsp;
                                            
                                            <b-button variant="info" @click="getLevelUsers">
                                                <i class="fas fa-user"></i> Current Level Users
                                            </b-button>
                                            &nbsp;
                                            |
                                            &nbsp;
                                            <b-button variant="info" @click="getAllLevelUsers(true)">
                                                <i class="fas fa-users"></i> Manage All Users
                                            </b-button>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-form>
                        </b-overlay>
                    </div>
                </b-col>
                <b-col cols="12" class="mt-1">
                    <div style="border: 1px solid lightgrey;  border-radius: 0.4rem;"><!--  overflow-x: scroll; -->
                        <!--<OrgChart :config="chart_config" v-if="hasMounted" />-->
                        <org-chart @selectedNode="selectedNodeEvent" v-if="hasMounted" :level_data="chart_config"></org-chart>
                    </div>
                </b-col>
                
            </b-row>
            <b-alert :show="!hasMounted">Loading</b-alert>
        </div>
        <UserLevelsModal v-if="show_modal" />
        <AllUsersModal v-if="show_all_modal" />
    </div>
</template>

<script>
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import _ from 'lodash'
import { clientAdminState, clientAdminMethods } from '@/state/helpers'

import UserLevelsModal from '../pre-inspection/levelUsersModal.vue'
import AllUsersModal from '../pre-inspection/allLevelUsersModal.vue'

export default {
    data:() => ({
        //Typeahead
        search_mode: 'name',
        query:'',
        debug:'',

        hasMounted: false,
        isLoadingUsers: false,
        chart_config: null,
        selected_level_id: null,
        edit:{
            name: '',
        },
        new_level_name: '',
        show_modal: false,
        show_all_modal: false,
    }),
    components:{
        UserLevelsModal,
        AllUsersModal,
        VueTypeaheadBootstrap,
    },
    computed:{
        ...clientAdminState,
        levelDetails(){
            if(this.selected_level_id != null){
                let id = Number(this.selected_level_id);
                let index = _.findIndex(this.user_levels, {id : id});
                if(index != -1){
                    return this.user_levels[index];
                }
                else{
                    return null;
                }
            }
            else{
                return null;
            }
        },
        users(){
            let data = [];
            if(this.users_in_level != null){
                this.users_in_level.forEach( user => {
                    data.push(user.name);
                })
            }

            return data;
        },
        
    },
    watch:{
        levelDetails(value){
            if(value != null){
                this.edit.name = this.levelDetails.name;
                if(this.levelDetails.lead_user.name != null){
                    this.query = this.levelDetails.lead_user.name;
                }
                else{
                    this.query = '';
                }
            }
        }
    },
    methods:{
        ...clientAdminMethods,

        findUser(string){
            if(this.users_in_level != null){
                let obj = _.find(this.users_in_level, { name : string });
                console.log('Found Object', obj);
                if(obj != undefined){
                    let params = {
                        level_id: this.selected_level_id,
                        user_id: obj.id,
                    }
                    this.saveLevelLead(params);
                }
            }
        },

        addLevel(){
            let params = {
                id: -1,
                name: this.new_level_name,
                parent_id: this.selected_level_id,
            }
            console.log(params);

            this.saveLevel(params)
            .then(()=>{
                this.new_level_name = '';
                this.$refs['addLevelDropdown'].hide();
                this.loadChartData();
                this.$swal.fire({ toast: true, position: 'top', iconColor: 'white', icon: 'success', title:'Saved New Level', customClass: {     popup: 'success-toast' }, showConfirmButton: false, timer: 2000, timerProgressBar: true});
            })
            .catch(()=>{
                alert('Error saving new level')
            })
        },
        deleteSelectedLevel(){
            let params = {
                id: this.selected_level_id
            }

            this.deleteLevel(params)
            .then(()=>{
                this.loadChartData();
            })
        },
        getAllLevelUsers( showModal = false){
            this.loadLevelUsers(0)
            .then(()=>{
                if(showModal){
                    this.show_all_modal = true;
                    this.$nextTick(()=>{
                        this.$bvModal.show('allUsersModal');
                        this.$root.$once('bv::modal::hidden',(event)=>{
                            if(event.type == 'hidden' && event.componentId == 'allUsersModal'){
                                this.show_all_modal = false;
                            }
                        })
                    })
                }
            })
        },
        
        getLevelUsers( showModal = false){
            this.isLoadingUsers = true;
            this.loadLevelUsers(this.selected_level_id)
            .then(()=>{
                this.isLoadingUsers = false;
                if(showModal){
                    this.show_modal = true;
                    this.$nextTick(()=>{
                        this.$bvModal.show('levelUsersModal');
                        this.$root.$once('bv::modal::hidden',(event)=>{
                            if(event.type == 'hidden' && event.componentId == 'levelUsersModal'){
                                this.show_modal = false;
                            }
                        })
                    })
                }
            })
            .catch((error)=>{
                console.log('Loading level users error', error);
                this.isLoadingUsers = false;
            })
        },

        selectedNodeEvent(id){
            let index = _.findIndex(this.user_levels, {id: Number(id)});
            if(index != -1){
                this.selected_level_id = id;
                this.$nextTick(()=>{
                    this.getLevelUsers();
                })
            }
            else{
                this.selected_level_id = null;
            }
            
        },

        loadChartData(){
            this.hasMounted = false;
            this.loadLevels()
            .then(()=>{
                let levels_data = _.clone(this.user_levels);

                this.chart_config = levels_data;
                this.$nextTick(()=>{
                    this.hasMounted = true;
                    if(this.selected_level_id != null){
                        this.selectedNodeEvent(this.selected_level_id);
                    }
                })
            })
            .catch(error => { console.log('LevelError', error) });
        },

        addUserToLevel(){
            let params = {

            }
            this.saveUserToLevel(params)
            .then(()=>{
                this.loadChartData()
                this.$swal.fire({ toast: true, position: 'top', iconColor: 'white', icon: 'success', title:'Saved User To Level', customClass: {     popup: 'success-toast' }, showConfirmButton: false, timer: 2000, timerProgressBar: true});
            })
        },
        saveCurrentLevel(){
            this.loadChartData()
        }
    },
    mounted(){
        this.loadChartData();
        //this.getAllLevelUsers();
    },
}
</script>

<style>
    .addLevelMenu{
        border: 1px solid grey;
        margin-top: 0.2rem;
    }
    .alert-info{
        padding-top: 7px;
        padding-bottom: 7px;
    }

    .list-group-item{
        background-color: rgb(191, 235, 255) !important;
    }
    .list-group-item>div:hover{
        text-decoration: underline;
    }
    
</style>